module.exports = __webpack_public_path__ + "static/media/icon-collection.43e09c0e.svg";